import defaultDetailsMarkdown from './DetailsSection.md?raw';

const DEFAULT_VARIANT = 'default';
const DEFAULT_LABELS = [
  'backend',
  'frontend',
  'documentation',
  'type::bug',
  'type::feature',
  'type::maintenance',
];
const DEFAULT_LABELS_TO_QUERY = [
  'quick win',
  'quick win::first-time contributor',
  'community-bonus::100',
  'community-bonus::200',
  'community-bonus::300',
  'community-bonus::500',
  'co-create',
  'Seeking community contributions',
];

export const VARIANTS = {
  [DEFAULT_VARIANT]: {
    shownLabels: [
      ...DEFAULT_LABELS,
      ...DEFAULT_LABELS_TO_QUERY,
    ],
    labelsToQuery: DEFAULT_LABELS_TO_QUERY,
    detailsMarkdown: defaultDetailsMarkdown,
  },
};

export const getVariant = name => VARIANTS[name] ?? VARIANTS[DEFAULT_VARIANT];
